export const scribblePosts = [
  {
    title: "It’s Not the Tool, It’s You",
    excerpt:
      "A glimpse of my journey with Chat GPT",
    content: "/scribble-content/chat-gpt-reflection.md",
    publicationDate: "10/5/2024",
  },
  {
    title: "Bread and Butter",
    excerpt:
      "Given my year and change of expertise, here are my go-to Boston restaurants",
    content: "/scribble-content/bread-and-butter.md",
    publicationDate: "10/4/2024",
  },
];
